// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.21-TSS-3028-mcastro-IMPROVEMENT-Spot-Length-Column.1";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
